import React, { useEffect, useState } from "react";
import { Button, Card, Col, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Row } from "react-bootstrap";
import moment from "moment";
import ConfirmationBox from "../ConfirmationBox";
import BatteryGraph from "./batteryGraph";
import { useDispatch, useSelector } from "react-redux";
import ShowMoreText from "react-show-more-text";
import { useCookies } from "react-cookie";
import { getBatteryLevelsFromAPi } from "../../redux/actions/battery-levels";
import DateRangePicker from 'react-bootstrap-daterangepicker';
const BatteryHistory = ({
  loading,
  handleDeleteRecord,
  handleRecordEdit,
  userToken,
  addBatteryState,
}) => {
  const [translation] = useTranslation("translations");
  const [remarks, setRemarks] = useState(false);
  const [editId, setEditId] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [isLoading, setIsLoading] = useState(loading);
  const [recordLoading, setRecordLoading] = useState(loading);
  const [recordEditLoading, setRecordEditLoading] = useState(loading);
  const [dateFilters, setDateFilters] = useState("this-week");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [customDates, setCustomDates] = useState('');
  const handleCloseConfirmation = () => setShowConfirmation(false);
  const batteryHistory = useSelector(
    (state) => state.batteryLevels.allBatteryLevels
  );
  const [cookies] = useCookies([
    "sustainyou_user_jwt",
    "sustainyou_jwt_issued",
    "sustainyou_jwt_expire",
  ]);
  const dispatch = useDispatch();
  useEffect(() => {
    const getNewRecords = async (date = "this-week", custom_dates = '') => {
      setIsLoading(true);
      setRecordLoading(true);
      await dispatch(getBatteryLevelsFromAPi(userToken, date, customDates));
      setIsLoading(false);
      setRecordLoading(false);
    };
    getNewRecords(dateFilters, customDates);
  }, [cookies.sustainyou_user_jwt, dateFilters, dispatch, userToken, customDates]);
  useEffect(() => {
    setDateFilters("this-week");
  }, [addBatteryState]);

  const handleCustomDatesSelect = ( start, end ) => {

    const startDate = moment(start).format("YYYY-MM-DD");
    const endDate = moment(end).format("YYYY-MM-DD");

    if ( startDate && endDate ) {
      setCustomDates( `${startDate},${endDate}` );
      setDateFilters("custom-dates");
    }

  }

  return (
    <Card
      className="bg-white mt-3 border-1 border-light"
      style={{ minHeight: `${window.location.pathname === "/" ? '' : '55vh' }` }}
    >
      <Card.Body className="p-0">
        <Row>
          <Col xs={12} lg={window.location.pathname === "/" ? 12 : 8}>
            <div className="row align-items-center justify-content-between m-0">
              <Col xs={6} md={4} lg={4}>
                <b>
                  <p className="text-blue p-3 m-0" style={{ fontSize: "20px" }}>
                    {translation("history")}
                  </p>
                </b>
              </Col>
              <Col xs={6} md={4} lg={8}>
                <div className="d-flex justify-content-end">
                  <select
                    key={addBatteryState}
                    className="form-select"
                    style={{
                      padding: "0.5rem 0.689rem 0.5rem 0.563rem",
                      width: "180px",
                      float: "right",
                    }}
                    value={dateFilters === 'custom-dates' ? 'custom' : dateFilters}
                    onChange={(e) => {
                      setDateFilters(e.target.value);
                    }}
                  >
                    <option value="this-week">{translation("this-week")}</option>
                    <option value="last-week">{translation("last-week")}</option>
                    <option value="this-month">
                      {translation("this-month")}
                    </option>
                    <option value="last-month">
                      {translation("last-month")}
                    </option>
                    <option value="this-year">{translation("this-year")}</option>
                    <option value="last-year">{translation("last-year")}</option>
                    <option value="custom">{translation("select_dates")}</option>
                  </select>
                  
                  { (dateFilters === 'custom' || dateFilters === 'custom-dates') &&
                    <div className="ms-2">
                      <DateRangePicker onCallback={(start, end) => handleCustomDatesSelect(start, end)}>
                      <input type="text" className="form-control" style={{maxWidth: '270px'}} />
                    </DateRangePicker>
                    </div>
                }
                </div>

              </Col>
            </div>
            <div>
              <BatteryGraph loading={isLoading} />
            </div>
          </Col>

          { window.location.pathname !== "/" &&
            <Col
              xs={12}
              md={4}
              lg={4}
              style={{ borderLeft: "1px solid #dee2e6" }}
            >
              <b>
                <p className="text-blue p-3 m-0" style={{ fontSize: "20px" }}>
                  {translation("records")}
                </p>
              </b>
              <div
                className="records-container"
                style={{ overflow: "auto", height: "400px" }}
              >
                {recordLoading ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <Spinner
                      animation="border"
                      size="sm"
                      style={{ color: "#cc9f00" }}
                    />
                  </div>
                ) : batteryHistory.data && batteryHistory.data?.length !== 0 ? (
                  batteryHistory.data?.map((record, index) => {
                    return (
                      <div
                        className="user-single-record border-1 border-top p-3"
                        key={index}
                      >
                        <span
                          style={{
                            fontSize: "12px",
                            borderRadius: "64px",
                          }}
                          className={`${
                            record?.battery_level >= 0 &&
                            record?.battery_level <= 20
                              ? "text-error-red bg-error-background px-2 py-2 mb-2"
                              : ""
                          } ${
                            record?.battery_level > 21 &&
                            record?.battery_level <= 80
                              ? "text-warn-yellow bg-warning-background px-2 py-2 mb-2"
                              : ""
                          } ${
                            record?.battery_level > 80 &&
                            record?.battery_level <= 100
                              ? "text-sustain-green bg-success-background px-2 py-2 mb-2"
                              : ""
                          }`}
                        >
                          {record?.battery_level + "%"}
                        </span>
                        <Row className="d-flex">
                          {editId === record?.id ? (
                            <div className="remark-edit-container">
                              <div className="input-group px-2 py-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={remarks || ""}
                                  onChange={(e) => setRemarks(e.target.value)}
                                />
                                <div className="input-group-append">
                                  <button
                                    className="btn btn-primary px-3 align-center"
                                    type="button"
                                    onClick={async () => {
                                      if (isLoading) {
                                        return;
                                      }
                                      setRecordEditLoading(true);
                                      await handleRecordEdit(
                                        record.id,
                                        remarks,
                                        record?.battery_level
                                      );
                                      setRecordEditLoading(false);
                                      setEditId("");
                                    }}
                                  >
                                    <span>
                                      {recordEditLoading ? (
                                        <Spinner
                                          animation="border"
                                          size="sm"
                                          style={{ color: "#ffffff" }}
                                        />
                                      ) : (
                                        <i className="fa fa-save text-white"></i>
                                      )}
                                    </span>
                                  </button>
                                </div>
                              </div>
                              <div className="text-right d-inline-block w-100">
                                <button
                                  type="button"
                                  className="text-secondary float-end btn btn-link pb-0"
                                  onClick={() => {
                                    setRemarks(record.remark);
                                    setEditId("");
                                  }}
                                >
                                  {translation("buttons.cancel")}
                                </button>
                              </div>
                            </div>
                          ) : (
                            <>
                              <Col xs={12} lg={7}>
                                <div
                                  className="text-black mb-0 mt-2"
                                  style={{ fontSize: "16px" }}
                                >
                                  <ShowMoreText
                                    /* Default options */
                                    lines={8}
                                    more={translation("show_more")}
                                    less={translation("show_less")}
                                    className="note-paragraph"
                                    anchorClass="my-anchor-css-class"
                                    expanded={false}
                                    truncatedEndingComponent={"... "}
                                  >
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: record?.remark,
                                      }}
                                    />
                                  </ShowMoreText>
                                </div>
                              </Col>
                              <Col
                                xs={12}
                                lg={5}
                                className="d-flex justify-content-lg-end records-div"
                              >
                                <div className="records-btn mt-2 mt-lg-0">
                                  <Button
                                    size="sm"
                                    className="m-1 bg-primary border-0"
                                    onClick={() => {
                                      setRemarks(record.remark);
                                      setEditId(record.id);
                                    }}
                                  >
                                    <i className="fa fa-pencil text-white"></i>
                                  </Button>
                                  <Button
                                    size="sm"
                                    className="m-1 bg-secondary border-0"
                                    onClick={() => {
                                      setDeleteId(record.id);
                                      setShowConfirmation(true);
                                    }}
                                  >
                                    {isLoading && deleteId === record?.id ? (
                                      <Spinner
                                        animation="border"
                                        size="sm"
                                        style={{ color: "#cc9f00" }}
                                      />
                                    ) : (
                                      <i className="fa fa-trash text-white"></i>
                                    )}
                                  </Button>
                                </div>
                              </Col>
                            </>
                          )}
                        </Row>

                        <span
                          className="text-mid-grey"
                          style={{ fontSize: "12px" }}
                        >
                          {moment(record.level_date).format("DD MMM YYYY")}
                          {"  "}
                          {moment(record.date).fromNow()}
                        </span>
                        <ConfirmationBox
                          show={showConfirmation}
                          handleClose={handleCloseConfirmation}
                          title={translation("delete_record_title")}
                          message={translation("delete_record_warning")}
                          confirmationAction={async () => {
                            setIsLoading(true);
                            await handleDeleteRecord(deleteId);
                            setShowConfirmation(false);
                            setIsLoading(false);
                            setDeleteId("");
                          }}
                          loading={isLoading}
                          size="sm"
                        />
                      </div>
                    );
                  })
                ) : (
                  <div className="d-flex justify-content-center align-items-center">
                    <p>{translation("no-records")}</p>
                  </div>
                )}
              </div>
            </Col>
          }
        </Row>
        <Card.Title style={{ fontWeight: "bold" }}></Card.Title>
      </Card.Body>
    </Card>
  );
};
export default BatteryHistory;
